/**
 * Status command - shows current session status
 *
 * Delegates to `list` since sessions are tracked via the local registry.
 */

import { list } from './list.js';

export async function status(): Promise<void> {
  await list({});
}
